function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.832 2.711a1.429 1.429 0 00-1.949-.52L7.766 8.588h16.47l-3.404-5.877z",
  fill: "url(#money_svg__paint0_linear)"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 11.588a3 3 0 013-3h22a3 3 0 013 3V27a3 3 0 01-3 3H5a3 3 0 01-3-3V11.588z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.766 19.294A3.294 3.294 0 0125.06 16H30v6.588h-4.94a3.294 3.294 0 01-3.294-3.294z",
  fill: "url(#money_svg__paint1_linear)"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 23.41,
  y: 17.647,
  width: 3.294,
  height: 3.294,
  rx: 1.647
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "money_svg__paint0_linear",
  x1: 10.854,
  y1: 2,
  x2: 21.046,
  y2: 7.827,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "money_svg__paint1_linear",
  x1: 23.31,
  y1: 16,
  x2: 29.561,
  y2: 17.787,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#89A6BE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#68869F"
})));

var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgMoney;